import React from 'react';
import Header from '../components/Header/Header';
import SEO from '../components/SEO/SEO';
import NewsfeedPanel from '../components/NewsfeedPanel/NewsfeedPanel';
import { PolymarketTradesTable, TopMarketsSection, PolymarketStats } from '../components/PolymarketTrades';
import { usePolymarketWebSocket } from '../hooks/usePolymarketWebSocket';
import './PolymarketPage.css';

const EMPTY_FILTERS = {};

function PolymarketPage() {
  // Connect to Polymarket WebSocket
  const {
    isConnected,
    isSubscribed,
    subscriptionError,
    trades,
    topMarkets,
    summary,
    historicalLoading: loading
  } = usePolymarketWebSocket(EMPTY_FILTERS, {
    enabled: true
  });

  // Handle trade click (for future popup/modal)
  const handleTradeClick = (trade) => {
    // Open Polymarket market page
    if (trade.marketSlug) {
      window.open(`https://polymarket.com/event/${trade.eventSlug || trade.marketSlug}`, '_blank');
    }
  };

  // Handle market click (for future market details)
  const handleMarketClick = (market) => {
    // Open Polymarket market page
    if (market.marketSlug) {
      window.open(`https://polymarket.com/event/${market.eventSlug || market.marketSlug}`, '_blank');
    }
  };

  return (
    <div className="polymarket-page">
      <SEO page="polymarket" />
      <Header
        isConnected={isConnected}
        isSubscribed={isSubscribed}
        subscriptionError={subscriptionError}
      />
      <h1 className="sr-only">Polymarket Whale Trades | TraderMap</h1>

      {/* Stats Bar */}
      <PolymarketStats summary={summary} loading={loading} trades={trades} />

      <div className="container-fluid">
        <div className="grid">
          {/* Left Column - Whale Trades */}
          <div className="g-col-12 g-col-lg-4">
            <PolymarketTradesTable
              trades={trades}
              loading={loading}
              onTradeClick={handleTradeClick}
            />
          </div>

          {/* Center Column - Top Markets */}
          <div className="g-col-12 g-col-lg-4">
            <TopMarketsSection
              markets={topMarkets}
              loading={loading}
              onMarketClick={handleMarketClick}
            />
          </div>

          {/* Right Column - News */}
          <div className="g-col-12 g-col-lg-4">
            <NewsfeedPanel variant="compact" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PolymarketPage;
